import React, { useContext, useEffect } from 'react';
import htmlParse from 'react-html-parser';
import { isMobile, isTablet } from 'react-device-detect';
import { gsap, Power1 } from 'gsap';
import AppContext from '../../../contexts/AppContext';
import './IntroLayer.css';

export default function IntroStart({
  currentLocation,
  loadedGallery,
  isSharedDefault,
}) {
  const { dictionnary } = useContext(AppContext);

  const animate = () => {
    const duration = 0.5;

    gsap.to(['.animated-intro-wrapper-0'], {
      opacity: 1,
      duration,
      ease: Power1.easeInOut,
      delay: 0,
    });
    gsap.to(['.animated-intro-wrapper-1'], {
      opacity: 1,
      duration,
      ease: Power1.easeInOut,
      delay: 0.7,
    });
    if (isMobile || isTablet) {
      gsap.to(['.animated-intro-wrapper-2'], {
        opacity: 1,
        duration,
        ease: Power1.easeInOut,
        delay: 1.4,
      });
    }
  };

  useEffect(() => {
    // Update the document title using the browser API
    animate();
  });

  const isShared = loadedGallery && !loadedGallery.default;
  let introText = '';
  if (!loadedGallery || loadedGallery.default || !currentLocation) {
    introText = dictionnary.get('intro-title');
  } else if (currentLocation) {
    const location = `${currentLocation.city}, ${currentLocation.name}`;
    introText = dictionnary
      .get('intro-shared-title-user')
      .replace('<location>', location);
  } else {
    introText = dictionnary.get('intro-title');
  }

  if (isMobile) {
    introText = introText.replace(' x ', '<br />x<br />');
  }

  if (isSharedDefault && currentLocation && loadedGallery.meta) {
    const location = `${currentLocation.city}, ${currentLocation.name}`;
    introText = dictionnary
      .get('intro-shared-title-bts')
      .replace('<band-members-name>', loadedGallery.meta.member)
      .replace('<location>', location);
  }

  const subtitleClass =
    !loadedGallery || loadedGallery.default
      ? 'intro-subtitle'
      : 'intro-subtitle-small';

  const introSubtitleTxt =
    isShared || isSharedDefault
      ? dictionnary.get('intro-subtitle-shared')
      : dictionnary.get(
          isMobile || isTablet ? 'intro-subtitle-mobile' : 'intro-subtitle',
        );

  const isLongTitle = introText.length > dictionnary.get('intro-title').length;

  return (
    <>
      <div
        id="intro-logo-title"
        className={`animated-intro-wrapper animated-intro-wrapper-0 ${
          isLongTitle ? 'long-title' : ''
        }`}
      >
        {htmlParse(introText)}
      </div>

      <div
        id={subtitleClass}
        className="animated-intro-wrapper animated-intro-wrapper-1"
      >
        {htmlParse(introSubtitleTxt)}
      </div>

      {(isMobile || isTablet) && (
        <div
          id="intro-mobile-subtitle"
          className="animated-intro-wrapper animated-intro-wrapper-2"
        >
          {htmlParse(dictionnary.get('intro-subtitle2-mobile'))}
        </div>
      )}
    </>
  );
}
